import * as getRoles from './reducers/get';
import * as createRole from './reducers/create';
import * as deleteRole from './reducers/delete';
import * as updateRole from './reducers/update';
import { simple } from 'src/utils/reducers';

// eslint-disable-next-line import/no-default-export
export default simple({
    ROLE_GET_REQUEST: getRoles.request,
    ROLE_GET_FINISH: getRoles.finish,
    ROLE_GET_ERROR: getRoles.error,

    ROLE_CREATE_REQUEST: createRole.request,
    ROLE_CREATE_FINISH: createRole.finish,
    ROLE_CREATE_ERROR: createRole.error,

    ROLE_DELETE_REQUEST: deleteRole.request,
    ROLE_DELETE_FINISH: deleteRole.finish,
    ROLE_DELETE_ERROR: deleteRole.error,

    ROLE_UPDATE_REQUEST: updateRole.request,
    ROLE_UPDATE_FINISH: updateRole.finish,
    ROLE_UPDATE_ERROR: updateRole.error,
});
